module.exports = __webpack_public_path__ + "img/nodata.54c40853.svg";